<template>
  <div
    class="cell-fine"
    :class="{ 'cell-fine-red': record.fine.value > 0, 'cell-fine_disabled': !canEdit }"
    @click="canEdit && (calculateType === 'byPeriod' ? (isShowFinesPeriodModal = true) : (isShowFinesPeriodModal = true))"
  >
   <!-- <m-write-fine
      v-if="calculateType === 'byDate'"
      :calc-data="calculationData"
      :record="record"
      :active="isShowWriteFineModal"
      @close="isShowWriteFineModal = false"
      @submitFines="submitFines"
    />-->
    <m-show-fines-period-modal
      v-if="calculateType === 'byPeriod'"
      :active="isShowFinesPeriodModal"
      :record="record"
      :calc-data="calculationData"
      @close="isShowFinesPeriodModal = false"
      @updateFines="updateFines"
    />
    <m-show-fines-period-modal
      v-if="calculateType === 'byDate'"
      :active="isShowFinesPeriodModal"
      :record="record"
      :calc-data="calculationData"
      @close="isShowFinesPeriodModal = false"
      @updateFines="updateFines"
    />
    <div :class="{ 'cell-fine-value-grey': record.fine.value == 0 }" class="cell-fine-value">
      {{ record.fine.value }}
    </div>
  </div>
</template>

<script>
import WriteFineModal from "@/pages/calculations/create/additions/modal-production-write-fine";
import ShowFinesByCalculationPeriod from "@/pages/calculations/create/additions/calculation-by-period-modals/show-fines-modal";

export default {
  name: "production-cell-fine",
  components: {
    "m-write-fine": WriteFineModal,
    "m-show-fines-period-modal": ShowFinesByCalculationPeriod,
  },
  props: ["record", "calculationData", "calculateType", "canEdit"],

  data() {
    return {
      isShowWriteFineModal: false,
      isShowFinesPeriodModal: false,
    };
  },
  methods: {
    updateFines(params) {
      this.$emit("updateFines", params)
    },
    submitFines(items) {
      let sum = 0;
      this.record.fine.items = [];
      items.forEach((item) => {
        sum += Number(item.amountLocal);
        this.record.fine.items.push({
          amount: item.amountLocal,
          author_id: item.authorLocalValue.value,
          reason: item.basisLocalValue.label,
          reason_id: item.basisLocalValue.value,
        });
      });
      this.record.fine.value = sum;
    },
  },
};
</script>
<style lang="scss" scoped>
.cell-fine {
  line-height: 13px;
  font-size: 13px;
  padding: 10px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &-red {
    background: #ffe6f2;
  }

  &:hover {
    outline-style: solid;
    outline-width: 1px !important;
    outline-color: #0066ff !important;
    box-shadow: 0 0 10px rgba(0, 102, 255, 0.4);
  }

  &_disabled {
    cursor: default;

    &:hover {
      outline: none;
      box-shadow: none;
    }
  }

  &-value {
    &-grey {
      color: #8e9cbb;
    }
  }
}
</style>
